import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const FlexRowReverse = ({ children, className = "space-x-2" }) => {
    const { language } = useLanguage();
    if (!className.includes("space-x")) {
        className += " space-x-2";
    }
    return (
        <div
            className={`flex flex-wrap flex-row ${
                language === "ar" ? "space-x-reverse" : ""
            }  ${className}`}
        >
            {children}
        </div>
    );
};

export default FlexRowReverse;
